import { UserProfilePage as UserAccountPage } from './UserAccountPage';
import { UiFeatureLite } from '@/app/feature';
import { FeatureCodes } from '@ssar-app/domain';

export const userAccountFeature: UiFeatureLite = {
  isDisabled: false,
  code: FeatureCodes.UserAccount,
  rootComponent: <UserAccountPage />,
};
